import { z } from 'zod'

/**
 * Validate build-time config once at module load so misconfiguration fails loud
 * and early rather than as obscure runtime errors.
 */
const schema = z.object({
  appName: z.string().min(1).default('vla'),
})

export const env = schema.parse({
  appName: import.meta.env.VITE_APP_NAME,
})

export type Env = z.infer<typeof schema>
